import * as data from "../actions/homes.data";
import * as ui from "../actions/homes.ui";

export interface State {
	loading: boolean;
	updating: boolean;
}

export const initialState: State = {
	loading: true,
	updating: false,
};

export function reducer(state = initialState, action: data.Actions | ui.Actions): State {
	switch (action.type) {
		case ui.LOADING: {
			return {
				...state,
				loading: true,
			};
		}
		case ui.UPDATING: {
			return {
				...state,
				updating: true,
			};
		}
		case data.UPDATE_HOME: {
			return {
				...state,
				updating: false,
			};
		}
		case data.SET_HOMES: {
			return {
				...state,
				loading: false,
			};
		}

		default:
			return state;
	}
}

export const getLoading = (state: State) => state.loading;
export const getUpdating = (state: State) => state.updating;
